import React, {memo} from 'react';
import './CartPickerTrigger.less';
import {CartPickerTriggerText} from 'elements/cart-picker-trigger-text/CartPickerTriggerText';

export const CartPickerTrigger = memo(({icon, text}) => {
	return (
		<div className="cart-picker-trigger">
			<span className="cart-picker-trigger__icon">{icon}</span>
			<span className="cart-picker-trigger__text">
        <CartPickerTriggerText text={text}/>
      </span>
		</div>
	);
});
